/**
 * Уведомление о файлах cookie (152-ФЗ).
 *
 * Режим уведомительный, российский, а не европейский: сообщаем об
 * обработке, а не спрашиваем разрешения. Из ЕС на сайт приходит 4,6%
 * посетителей, из России 76%, компания российская. Европейский режим
 * потребовал бы блокировать счётчик до согласия и вести журнал согласий,
 * то есть решать чужую задачу ценой работы сайта.
 *
 * Отсюда и одна кнопка. «Принять» и «отклонить» — это про согласие; если
 * отклонение ничего не выключает, кнопка «отклонить» просто врёт.
 */

/**
 * Отметка о том, что уведомление закрыто.
 *
 * Имя не служебное и читаемое: оно перечислено в политике, и человек,
 * заглянувший в список своих cookie, должен узнать его там.
 */
export const KUKA_COOKIE = 'aisearch_cookie_notice';

/** Год. Уведомление показывается один раз, а не при каждом заходе. */
export const SROK_COOKIE_SEKUND = 365 * 24 * 60 * 60;

/** Раздел политики про файлы cookie. */
export const PUT_POLITIKI = '/legal/privacy#cookie';

/**
 * Адрес, по которому уведомление закрывается без скриптов.
 *
 * Скрипт ставит куку сам и убирает полосу без перезагрузки, но работать
 * обязано и без него: человек с отключённым JS иначе видел бы полосу
 * вечно.
 */
export const PUT_PONYATNO = '/ais-cookie/ponyatno';

/**
 * Пути, на которых уведомления быть не должно.
 *
 * Те же, что у плашки о новой версии: служебные ответы это файлы для
 * машин, а HTML внутри JSON ломает разбор у клиента.
 */
const SLUZHEBNYE = [
  '/api/',
  '/_next/',
  '/robots.txt',
  '/sitemap.xml',
  '/llms.txt',
  '/manifest.json',
  '/sw.js',
  PUT_PONYATNO,
];

/**
 * Показывать ли уведомление.
 *
 * Только на русской витрине: счётчик Метрики стоит на ней, и 152-ФЗ
 * касается российского посетителя. На международном домене своё
 * регулирование и свой разговор, и смешивать их в одной полосе нельзя.
 */
export function pokazyvatCookie(opisanie: {
  ruDomen: boolean;
  prinyato: boolean;
  put: string;
}): boolean {
  if (!opisanie.ruDomen) return false;
  if (opisanie.prinyato) return false;
  return !SLUZHEBNYE.some((sluzhebnyj) => opisanie.put.startsWith(sluzhebnyj));
}

/**
 * Адрес закрытия с возвратом на ту же страницу.
 *
 * Нужен только запасному пути без JS. Возврат проверяется на той
 * стороне: принимается лишь внутренний путь, иначе адрес превращается в
 * открытый перенаправитель.
 */
export function adresPonyatno(put: string, zapros?: string): string {
  const nazad = put + (zapros !== undefined && zapros !== '' ? normalizovat(zapros) : '');
  return `${PUT_PONYATNO}?nazad=${encodeURIComponent(nazad)}`;
}

/** Строка запроса ровно с одним ведущим «?». */
function normalizovat(zapros: string): string {
  return zapros.startsWith('?') ? zapros : `?${zapros}`;
}
